<template>
  <div v-if="desc" class="rights-desc">
    <TitleLabel :title="desc.title" />
    <div v-show="desc.subtitle" class="pt-[12px] text-[14px] leading-[24px] opacity-60">
      {{ desc.subtitle }}
    </div>
    <div class="h-[1px] bg-back-3 mt-[15px] mb-[20px] font"></div>
    <ul>
      <li
        v-for="cont in desc.items"
        v-show="cont.rights_content[rightsType]?.title"
        :key="cont.title"
      >
        <div
          :class="cont.rights_content[rightsType]?.value ? 'circle-bg' : 'circle-close-bg'"
          class="w-[20px] p-1 h-[20px] mr-1 scale-[0.6] justify-center flex-y-center rounded-full"
        >
          <iconpark-icon
            v-if="cont.rights_content[rightsType]?.value"
            name="check-thin"
            size="12"
          />
          <iconpark-icon v-else name="close" size="14" />
        </div>
        <div class="flex flex-col">
          <div class="flex items-start">
            {{ cont.rights_content[rightsType]?.title }}
            <Tooltip
              v-show="cont.rights_content[rightsType]?.hover"
              theme="light"
              placement="right"
            >
              <template #content>
                {{ cont.rights_content[rightsType]?.hover }}
              </template>
              <iconpark-icon
                v-show="cont.rights_content[rightsType]?.hover"
                name="question-dbkp1hal"
                size="12"
                class="ml-1 mt-1"
              />
            </Tooltip>
            <authorization-differences
              v-if="cont?.title === $t('shang-yong-shou-quan')"
              v-slot="{ show }"
              class="inline-block"
              :onCloseParent="onCloseParent"
            >
              <iconpark-icon name="question-dbkp1hal" size="12" class="ml-1 mt-1" @click="show" />
            </authorization-differences>
          </div>
          <div
            v-if="cont.rights_content[rightsType]?.subtitle"
            class="flex text-[var(--text-1-70)] items-start mt-1"
          >
            {{ cont.rights_content[rightsType]?.subtitle }}
            <Tooltip
              v-show="cont.rights_content[rightsType]?.subhover"
              theme="light"
              placement="right"
            >
              <template #content>
                {{ cont.rights_content[rightsType]?.subhover }}
              </template>
              <iconpark-icon
                v-show="cont.rights_content[rightsType]?.subhover"
                name="question-dbkp1hal"
                size="12"
                class="ml-1 mt-1"
              />
            </Tooltip>
          </div>
        </div>
      </li>
    </ul>
    <span
      class="absolute bottom-[18px] text-bold left-[30px] text-[16px] text-primary cursor-pointer"
      @click="goSubscribe"
    >
      {{ $t('cha-kan-wan-zheng-quan-yi-dui-bi') }}
      <RightOutlined class="text-[12px]" />
    </span>
  </div>
</template>

<script setup lang="ts" name="RightsDesc">
import Tooltip from '@rendora/design/components/tooltip/Tooltip.vue';
import { USER_LEVEL_KEY } from '~/api/interface/auth';
import type { IRightsCompare } from '~/api/interface/rights';
import { PageKey } from '~/constants/page';
import TitleLabel from '../titleLabel/index.vue';
import AuthorizationDifferences from './authorization-differences.vue';

const props = defineProps<{
  desc?: IRightsCompare;
  rightsType: USER_LEVEL_KEY;
  onCloseParent?: () => void;
}>();
const goSubscribe = () => {
  if (props?.onCloseParent) {
    props.onCloseParent();
  }

  navigateTo({ name: PageKey.SUBSCRIBE });
};
</script>

<style lang="scss" scoped>
.rights-desc {
  @apply bg-back-1;
  padding: 24px;
  width: 292px;
  border-radius: 12px;
  &__title {
    font-size: 16px;
    line-height: 22px;
  }
  ul {
    padding-bottom: 40px;
    li {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      font-size: 14px;
      line-height: 20px;
      color: var(--text-1);
    }
  }
  .line {
    height: 1px;
    background: var(--back-4);
  }

  .circle-bg {
    background: var(--purple-1);
    color: #726bff;
  }
  .circle-close-bg {
    background: #ffdddd;
    color: #ff5757;
  }
}
</style>
